// extracted by mini-css-extract-plugin
export default {"root":"DeleteModal_root__b3wA1","container":"DeleteModal_container__KDOZg"};